<template>
  <!--<el-radio-group-->
  <!--v-if="env === 'development'"-->
  <el-radio-group
    v-model="locale"
    size="small"
  >
    <el-radio-button label="en-US">
      En
    </el-radio-button>
    <el-radio-button label="ru-RU">
      Ru
    </el-radio-button>
  </el-radio-group>
</template>

<script>
import { mapActions } from 'vuex';
import {
  UPDATE_LOCALE
} from '@/app/store/action-types';

export default {
  name: 'ALanguageToggle',
  data: () => ({
    env: process.env.NODE_ENV
  }),
  computed: {
    locale: {
      get() {
        return this.$store.state.locale;
      },
      set(value) {
        this.updateLocale(value);
      }
    }
  },
  methods: {
    ...mapActions({
      updateLocale: UPDATE_LOCALE
    })
  }
};
</script>
